import Vue from 'vue'
import Router from 'vue-router'
import { shouldUseMobile, isMobileRoute, applyViewport } from '@/utils/device'
import { resolveMobilePath } from './mobile-map'
Vue.use(Router)

const router = new Router({
  routes: [{
    path: '/',
    redirect: '/index'
  },
  {
    path: '/',
    component: resolve => require(['@/pages/index/index.vue'], resolve),
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Project',
        component: () => import('@/pages/index/body/body'),
      },
      {
        path: "testcenter",
        name: "testcenter",
        component: () => import("@/pages/index/testcenter/testcenter")
      },
      {
        path: "testbank-detail/:id",
        name: "testbank-detail",
        component: () => import("@/pages/index/testbank-detail/testbank-detail")
      },
      {
        path: "wrong-questions",
        name: "wrong-questions",
        component: () => import("@/pages/index/wrong-questions/wrong-questions")
      },
      {
        path: "recitation",
        name: "recitation",
        component: () => import("@/pages/index/recitation/recitation")
      },
      {
        path: "recitation-detail/:id",
        name: "recitation-detail",
        component: () => import("@/pages/index/recitation/recitation-detail")
      },

      {
        path: "examcenter",
        name: "examcenter",
        component: () => import("@/pages/index/examcenter/examcenter")
      },
      {
        path: "exam-detail/:id",
        name: "exam-detail", 
        component: () => import("@/pages/index/exam-detail/exam-detail")
      },
      {
        path: "serveset",
        name: "serveset",
        component: () => import("@/pages/index/serveset/serveset")
      },
      {
        path: "kaoshidaojishi",
        name: "kaoshidaojishi",
        component: () => import("@/pages/index/kaoshidaojishi/kaoshidaojishi")
      },
      {
        path: "hongbang",
        name: "hongbang",
        component: () => import("@/pages/index/hongbang/hongbang")
      },
      {
        path: "videopage",
        name: "videopage",
        component: () => import("@/pages/index/videopage/videoplayer")
      },
      {
        path: "videodetailspage",
        name: "videodetailspage",
        component: () => import("@/pages/index/videoDetailsPage/videodetailspage")
      },
      {
        path: "ocr",
        name: "ocr",
        component: () => import("@/pages/index/ocr/ocr")
      },
      {
        path: "Vip",
        name: "Vip",
        component: () => import("@/pages/index/Vip/Vip")
      },
      {
        path: "qianduanzixue",
        name: "qianduanzixue",
        component: () => import("@/pages/index/qianduanzixue/qianduan")
      },
      {
        path: "qianduan",
        name: "qianduan",
        component: () => import("@/pages/index/qianduan/qianduan")
      },
      {
        path: "houduan",
        name: "houduan",
        component: () => import("@/pages/index/houduan/houduan")
      },
      {
        path: "ceshi",
        name: "ceshi",
        component: () => import("@/pages/index/ceshi/ceshi")
      },
      {
        path: "tool",
        name: "tool",
        component: () => import("@/pages/index/tool/tool")
      },
      {
        path: "javacourse",
        name: "javacourse",
        component: () => import("@/pages/index/JavaCourse/JavaCourse")
      }, {
        path: '/QRcodeGeneration',
        name: 'QRcodeGeneration',
        component: () => import("@/pages/index/tool/QRcodeGeneration")
      }, {
        path: '/Base64Encoding',
        name: 'Base64Encoding',
        component: () => import("@/pages/index/tool/Base64Encoding")
      }, {
        path: '/IP',
        name: 'IP',
        component: () => import("@/pages/index/tool/IP")
      }, {
        path: '/Md5Encryption',
        name: 'Md5Encryption',
        component: () => import("@/pages/index/tool/Md5Encryption")
      }, {
        path: '/SqlCodeFormat',
        name: 'SqlCodeFormat',
        component: () => import("@/pages/index/tool/SqlCodeFormat")
      }, {
        path: '/WordsNumber',
        name: 'WordsNumber',
        component: () => import("@/pages/index/tool/WordsNumber")
      }, {
        path: '/JsonCodeFormat',
        name: 'JsonCodeFormat',
        component: () => import("@/pages/index/tool/JsonCodeFormat")
      }, {
        path: '/NumMoney',
        name: 'NumMoney',
        component: () => import("@/pages/index/tool/NumMoney")
      },
      {
        path: "courseclassification",
        name: "Courseclassification",
        component: () => import("@/pages/index/Courseclassification/Courseclassification.vue")
      },
      {
        path: "userhome",
        name: "userhome",
        redirect: '/userhome/allcourses',
        component: () => import("@/pages/index/userhome/userhome.vue"),
        children: [
          {
            path: "allcourses",
            name: "allcourses",
            component: () => import("@/pages/index/userhome/components/MyCourse.vue"),
          },
          {
            path: "allorders",
            name: "allorders",
            component: () => import("@/pages/index/userhome/components/MyOrder.vue"),
          },
          {
            path: "allfollows",
            name: "allfollows",
            component: () => import("@/pages/index/userhome/components/MyFollow.vue"),
          },
          {
            path: "notebook",
            name: "notebook",
            component: () => import("@/pages/index/userhome/components/MyNotebook.vue"),
          },
        ]
      },
      {
        path: "user",
        name: "user",
        redirect: '/user/setbindsns',
        component: () => import("@/pages/index/userhome/user-detail.vue"),
        children: [
          {
            path: "setbindsns",
            name: "setbindsns",
            component: () => import("@/pages/index/userhome/components/SetBindsns.vue"),
          },
          {
            path: "setprofile",
            name: "setprofile",
            component: () => import("@/pages/index/userhome/components/SetProfile.vue"),
          },
          {
            path: "oplog",
            name: "oplog",
            component: () => import("@/pages/index/userhome/components/Oplog.vue"),
          },
          {
            path: "authenticate",
            name: "authenticate",
            component: () => import("@/pages/index/userhome/components/Authenticate.vue"),
          },
          {
            path: "address",
            name: "address",
            component: () => import("@/pages/index/userhome/components/Address.vue"),
          },
        ]
      },
      {
        path: "vb_category_list",
        name: "vb_category_list",
        component: () => import("@/pages/index/VBscan/vb_category_list")
      },
      {
        path: "vb_assignment",
        name: "vb_assignment",
        component: () => import("@/pages/index/VBscan/vb_assignment")
      },
      {
        path: "server_category_list",
        name: "server_category_list",
        component: () => import("@/pages/index/servescan/server_category_list")
      },
      {
        path: "server_assignment",
        name: "server_assignment",
        component: () => import("@/pages/index/servescan/server_assignment")
      },
      {
        path: "pka_category_list",
        name: "pka_category_list",
        component: () => import("@/pages/index/list/pka_category_list")
      },
      {
        path: "pka_assignment",
        name: "pka_assignment",
        component: () => import("@/pages/index/list/pka_assignment")
      },
      {
        path: "test",
        name: "test",
        component: () => import("@/pages/test/test")
      }
    ]
  },
  {
    path: "/practice",
    name: "practice",
    component: () => import("@/pages/index/practice/practice")
  },
  {
    // 背诵学习页，和 /practice 一样走沉浸式独立布局
    path: "/recite",
    name: "recite",
    component: () => import("@/pages/index/recitation/recite")
  },
  {
    path: "/teacher-panel",
    name: "teacher-panel",
    component: () => import("@/pages/teacher-panel/teacher-panel")
  },
  {
    path: "/teacher-panel/grading",
    name: "grading",
    component: () => import("@/pages/teacher-panel/grading/grading")
  },
  {
  path: '/vm/',
  component: resolve => require(['@/pages/index/servescan/vmindex.vue'], resolve),
  redirect: '/testdetail',
  children: [
    {
      path: "testdetail",
      name: "testdetail",
      component: () => import("@/pages/index/servescan/testdetail")
    },]
  },
  {
  path: '/vb/',
  component: resolve => require(['@/pages/index/VBscan/vbindex.vue'], resolve),
  redirect: '/testdetail',
  children: [
    {
      path: "testdetail",
      name: "testdetail",
      component: () => import("@/pages/index/VBscan/testdetail")
    },]
  },

  {
    path: '/index',
    name: 'index',
    component: resolve => require(['@/pages/index/index.vue'], resolve),
  },
  // ==================== 移动端 ====================
  // 独立的一套精简页面，PC 代码完全不受影响，靠下面的 beforeEach 分流
  {
    path: '/m',
    component: () => import('@/pages/mobile/layout/MobileLayout.vue'),
    children: [
      {
        path: '',
        name: 'm-home',
        component: () => import('@/pages/mobile/home/Home.vue')
      },
      {
        path: 'login',
        name: 'm-login',
        component: () => import('@/pages/mobile/login/Login.vue')
      },
      {
        path: 'pc-only',
        name: 'm-pc-only',
        component: () => import('@/pages/mobile/common/PcOnly.vue')
      },
      {
        path: 'recitation',
        name: 'm-recitation',
        component: () => import('@/pages/mobile/recitation/List.vue')
      },
      // plan 必须排在 :id 前面，否则 /m/recitation/plan 会被当成 id=plan
      {
        path: 'recitation/plan',
        name: 'm-recitation-plan',
        component: () => import('@/pages/mobile/recitation/Plan.vue')
      },
      {
        path: 'recitation/:id',
        name: 'm-recitation-detail',
        component: () => import('@/pages/mobile/recitation/Detail.vue')
      },
      {
        path: 'recite',
        name: 'm-recite',
        component: () => import('@/pages/mobile/recitation/Recite.vue')
      },
      {
        path: 'testbank',
        name: 'm-testbank',
        component: () => import('@/pages/mobile/testbank/List.vue')
      },
      {
        path: 'testbank/:id',
        name: 'm-testbank-detail',
        component: () => import('@/pages/mobile/testbank/Detail.vue')
      },
      {
        path: 'practice',
        name: 'm-practice',
        component: () => import('@/pages/mobile/testbank/Practice.vue')
      },
      {
        path: 'course',
        name: 'm-course',
        component: () => import('@/pages/mobile/course/List.vue')
      },
      // play 必须排在 :id 前面，否则 /m/course/play 会被当成 id=play
      {
        path: 'course/play',
        name: 'm-course-play',
        component: () => import('@/pages/mobile/course/Play.vue')
      },
      {
        path: 'course/:id',
        name: 'm-course-detail',
        component: () => import('@/pages/mobile/course/Detail.vue')
      },
      {
        path: 'mine',
        name: 'm-mine',
        component: () => import('@/pages/mobile/mine/Mine.vue')
      },
      {
        path: 'mine/collect',
        name: 'm-mine-collect',
        component: () => import('@/pages/mobile/mine/Collect.vue')
      },
      {
        path: 'mine/wrong',
        name: 'm-mine-wrong',
        component: () => import('@/pages/mobile/mine/Wrong.vue')
      },

      // ---- 手机版后台。范围只有背诵管理，其余模块仍然只在电脑版 ----
      {
        path: 'admin',
        name: 'm-admin',
        component: () => import('@/pages/mobile/admin/AdminHome.vue')
      },
      {
        path: 'admin/recitation',
        name: 'm-admin-recitation',
        component: () => import('@/pages/mobile/admin/RecitationAdmin.vue')
      },
      // 带参数的排最后，避免把固定路径吃掉
      {
        path: 'admin/recitation/item/:id',
        name: 'm-admin-item',
        component: () => import('@/pages/mobile/admin/ItemDetail.vue')
      }
    ]
  },
  ],
  linkActiveClass: 'active',
   scrollBehavior () {
    return { x: 0, y: 0 }
  }

})

/**
 * PC / 移动端分流。
 *
 * 只做「手机 → 移动版」这一个方向的强制跳转：
 *   - PC 访问 /m/* 不拦截，方便调试和把移动端链接分享到桌面
 *   - 用户手动选了电脑版（localStorage.viewMode='pc'）后不再拦截
 *   - ?pc=1 可临时强制电脑版，用于排查问题
 *
 * 注意本项目是 hash 模式路由，所有页面跳转必须走 router，
 * 不能用 window.location.href='/xxx' —— 那会当成服务端路径，
 * 生产环境要么 404 要么被 proxy 吃掉。
 */
router.beforeEach((to, from, next) => {
  // URL 上带 ?pc=1 视为手动切电脑版
  if (to.query && to.query.pc === '1') {
    try { localStorage.setItem('viewMode', 'pc') } catch (e) { /* 隐私模式忽略 */ }
    applyViewport(false)
    return next()
  }

  // ?m=1 反向逃生口：把用户从「永久电脑版」里捞回来
  if (to.query && to.query.m === '1') {
    try { localStorage.setItem('viewMode', 'mobile') } catch (e) { /* 隐私模式忽略 */ }
  }

  // 手机版后台只给教师看。
  // ⚠️ 这只是界面遮挡：/api/admin/v1/recitation/** 在后端没有登录拦截，
  // 谁都能直接构造请求写生产库。真正的修法是在后端
  // cc/config/InterceptorConfig.java 的 addPathPatterns 里补 "/api/admin/*/**"。
  if (to.path.indexOf('/m/admin') === 0) {
    let role = ''
    try { role = localStorage.getItem('role') || '' } catch (e) { role = '' }
    if (role !== 'teacher') {
      applyViewport(true)
      return next({ path: '/m/mine', replace: true })
    }
  }

  // 已经在移动端路由里，放行
  if (isMobileRoute(to.path)) {
    applyViewport(true)
    return next()
  }

  // 不是手机、或用户选了电脑版，放行
  if (!shouldUseMobile()) {
    applyViewport(false)
    return next()
  }

  // 传 query 是因为课程详情 PC 端用 ?id=12 传参，需要提到移动端的 path 里
  const target = resolveMobilePath(to.path, to.query)
  // 解析结果和当前路径相同就别再跳，避免死循环
  if (target.path === to.path) return next()

  next({
    path: target.path,
    // pc-only 页要带上来源，其余保留原 query（如 ?mode=daily）
    query: target.query || to.query,
    replace: true
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js